/* ZUZU parallax + wave-motion engine.
   ---------------------------------------------------------------
   A single rAF-throttled scroll loop that:
     • gives the hero arch, section photos and copy gentle depth
       (translateY proportional to their position in the viewport)
     • shifts the dune dividers horizontally as they scroll past
       ("flow" wave mode) on top of their ambient CSS drift
   Driven by two <html> attributes set from the Tweaks panel:
     data-parallax   = off | soft | bold
     data-wavemotion = off | drift | flow   (flow = scroll shift)
   Fully bypassed under prefers-reduced-motion so it never fights
   accessibility, print or PDF export. SPA-aware (re-scans on DOM
   change) so it keeps working as React swaps pages. */
(function () {
  var reduceMQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMQ && reduceMQ.matches) return;

  // [selector, speed] — negative rises (feels further back / faster),
  // positive sinks (drifts down, feels closer). Kept gentle on purpose.
  var TARGETS = [
    ['.hero[data-layout="portal"] .hero-arch', -0.12],
    ['.hero[data-layout="stage"] .hero-stage', -0.10],
    ['.hero[data-layout="bleed"] .hero-bg', -0.10],
    ['.hero-copy', 0.05],
    ['.mod-spread .picture', -0.07],
    ['.md-hero-grid .picture', -0.07],
    ['.visit-photo', -0.06],
    ['.manifesto .inner', 0.05]
  ];

  var items = [];   // { el, speed }
  var waves = [];   // .wb-track elements
  var factor = 1;   // parallax intensity (0 = off)
  var flow = true;  // wave scroll-shift on?
  var vh = window.innerHeight || 800;

  function gather() {
    items = [];
    for (var t = 0; t < TARGETS.length; t++) {
      var nodes = document.querySelectorAll(TARGETS[t][0]);
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].classList.add('px-el');
        items.push({ el: nodes[i], speed: TARGETS[t][1] });
      }
    }
    waves = [];
    var tracks = document.querySelectorAll('.wave-break .wb-track');
    for (var w = 0; w < tracks.length; w++) waves.push(tracks[w]);

    // decorrelate the ambient drift so the dividers don't move in lockstep
    var fills = document.querySelectorAll('.wb-fill');
    for (var f = 0; f < fills.length; f++) {
      var s = fills[f];
      if (s.dataset.seed) continue;
      s.dataset.seed = '1';
      s.style.animationDelay = (-(Math.random() * 9)).toFixed(2) + 's';
      s.style.animationDuration = (11 + Math.random() * 7).toFixed(1) + 's';
    }
  }

  function readMode() {
    var d = document.documentElement;
    var p = d.getAttribute('data-parallax');
    factor = p === 'bold' ? 1.7 : p === 'off' ? 0 : 1; // soft = default
    flow = d.getAttribute('data-wavemotion') === 'flow';
  }

  var ticking = false;
  // Reads (getBoundingClientRect) are batched across every item/wave BEFORE
  // any write. Reading right after a write forces a synchronous layout flush
  // — done once per item in a loop, that's a forced reflow per element, on
  // every scroll frame. Two passes (read all, then write all) means at most
  // one flush for the whole frame instead of one per item.
  function update() {
    ticking = false;
    var mid = vh / 2;
    var i;
    if (factor > 0) {
      var rects = [];
      for (i = 0; i < items.length; i++) rects.push(items[i].el.getBoundingClientRect());
      for (i = 0; i < items.length; i++) {
        var it = items[i], r = rects[i];
        if (r.height === 0) continue;               // hidden (app view)
        if (r.bottom < -200 || r.top > vh + 200) continue; // far off-screen
        var center = r.top + r.height / 2;
        var prog = (mid - center) / vh;             // ~ -1 .. 1
        var y = prog * it.speed * vh * 0.6 * factor;
        it.el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      }
    } else {
      for (i = 0; i < items.length; i++) items[i].el.style.transform = '';
    }

    if (flow) {
      // visible glide as the divider crosses the viewport, scaled down on
      // narrow screens so the oversized svg always keeps the edges covered
      // (the dune svg overhangs 15% each side, so amp must stay under that)
      var amp = Math.min(130, (window.innerWidth || 1200) * 0.12);
      var waveRects = [];
      for (i = 0; i < waves.length; i++) waveRects.push(waves[i].getBoundingClientRect());
      for (i = 0; i < waves.length; i++) {
        var wr = waveRects[i];
        if (wr.height === 0) continue;
        var wp = (mid - (wr.top + wr.height / 2)) / vh;
        if (wp > 0.7) wp = 0.7; else if (wp < -0.7) wp = -0.7;
        waves[i].style.setProperty('--wx', (wp * amp).toFixed(1) + 'px');
      }
    } else {
      for (i = 0; i < waves.length; i++) waves[i].style.setProperty('--wx', '0px');
    }
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }

  function start() {
    gather();
    readMode();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight || 800; update(); });

    // Tweaks panel flips the <html> attributes — react immediately.
    new MutationObserver(function () { readMode(); update(); })
      .observe(document.documentElement, { attributes: true, attributeFilter: ['data-parallax', 'data-wavemotion'] });

    // React swaps pages/screens — re-scan after the DOM settles.
    var pending = null;
    new MutationObserver(function (muts) {
      for (var k = 0; k < muts.length; k++) {
        if (muts[k].addedNodes && muts[k].addedNodes.length) {
          clearTimeout(pending);
          pending = setTimeout(function () { gather(); update(); }, 140);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
